import History from './history';
import SearchLoader from './search';
import * as $ from "jquery";

export default class ContentLoader {
  contextPath: any;
  dataUrl: string;
  history: any;
  pages: any[];
  pageHistory: string[];
  isLocalizedContent: boolean;
  pageRenderHookEventName: string;

  constructor(contextPath) {
    this.contextPath = contextPath;
    this.dataUrl = "/git/_content";
    this.history = new History();
    this.pages = [];
    this.pageHistory = [window.location.pathname];
    this.isLocalizedContent = this.checkLocalizedDomain();

    this.initialize();

    /**
     * Trigger event for optimizely, etc. to hook into page changes
     * e.g.
     *  $(document).on("GitPageRender", function(e) { foo(); });
     */
    this.pageRenderHookEventName = "GitPageRender";
  }

  checkLocalizedDomain() {
    var hostnameParts = window.location.hostname.split(".");
    var i18nDomains = ["es", "de", "fr", "ja", "br", "ru", "ko"];

    if (i18nDomains.indexOf(hostnameParts[0]) > -1) {
      return true;
    }
    return false;
  }

  initialize() {
    var self = this;
    // Toggle main menu
    $(".hamburger").on("click", function () {
      $(".hamburger, .primary-nav").toggleClass("is-active");
    });

    // Check for fragment in url and scroll to before loading microsite
    var deeplinkId = self.getSectionFragment();
    if (deeplinkId) {
      self.scrollTo($(deeplinkId));
    }

    // Set Active States on UX
    self.setUXState();
  }

  getContent() {
    var self = this;

    $.ajax({
      url: this.contextPath + this.dataUrl,
      type: "GET",
      dataType: "json"
    })
      .done(function (json) {
        if ("undefined" !== typeof json["pages"]) {
          $("body").addClass("content-loaded");
          self.pages = json.pages;
          self.bindRoutes();

          // Initialize Search
          new SearchLoader(json.pages);
        }
      });
  }

  bindRoutes() {
    var self = this;

    // Intercept link clicks and route, or replace content if part of microsite
    $(document).on("click", "a", function (e) {

      //Check for i18n domain
      if (!self.isLocalizedContent) {
        var $link = $(this);
        var href = $link.attr("href");
        var externalPattern = /^https?:\/\//i;
        var isFullUri = externalPattern.test(href);

        if (isFullUri) {
          return true;
        }

        // @todo: work-around can be removed here once wysiwyg fixed for internal links
        href = href.replace(".html", "");

        // Check for same page anchor link
        if (href.charAt(0) !== "#") {
          e.preventDefault();

          // Check for search close state
          if ($link.hasClass("search-close")) {
            var searchBackLink = self.pageHistory.length > 1 ? self.pageHistory[self.pageHistory.length - 2] : href;
            return self.parseLink(searchBackLink);
          }

          return self.parseLink(href);
        }
      }
    });

    // Intercept pop state to check for app url and load content via js
    window.addEventListener('popstate', function () {
      self.parseLink(location.href, true);
    });
  }

  parseLink(href, disablePushState) {
    if (!href) {
      return true;
    }

    // Check for an external link or a non-microsite link, proceed as normal link if found
    var paths = href.split("/");
    if (paths.indexOf("git") === -1 && href.indexOf("/git#") === -1) {
      window.location = href;
      return true;
    }

    // Get page path by popping paths, key starts with /git/ path partial
    while (paths.length) {
      if (paths[0] === "git") {
        break;
      }
      paths.shift();
    }

    var pageGrp = paths.join("/").split("?");
    var pageKey = pageGrp[0].split("#")[0];

    this.dispatchPage(pageKey, href, disablePushState);

    return false;
  }

  dispatchPage(pageKey, href, disablePushState) {
    var pageContent = this.pages[pageKey];

    // Default to homepage
    if (typeof pageContent === "undefined") {
      pageContent = this.pages["git"];
    }

    if (typeof pageContent.dom === "undefined") {
      // Error checking - load the page as normal if some reason js breaks down
      window.location = href;
      return true;
    }

    // Replace page content
    $("#content").empty();

    $(".topbar a").text(pageContent.topbar.text).attr("href", pageContent.topbar.href).parent().attr("class", "").addClass("_header -" + pageContent.topbar.cls);

    this.renderContent(pageContent.dom, href);

    // Update meta tags
    $('meta[name=description]').attr('content', pageContent.meta.description);
    $('link[rel=canonical]').attr('href', pageContent.meta.canonical);

    if (!disablePushState) {
      this.history.pushState({}, pageContent.meta.title, href, window.location.href);
      this.pageHistory.push(href);
    }

    // Reset UI states
    this.setUXState(pageContent.flags);

    var deeplinkId = this.getSectionFragment(href);
    if (deeplinkId) {
      this.scrollTo($(deeplinkId));
    } else {
      $("html, body").animate({ scrollTop: 0 }, 0);
    }
  }

  renderContent(domList, href) {
    var self = this;
    var content = $("#content");

    if (!content.length) { return; }

    domList.forEach(function (val) {
      try {
        var el = self.jsonToDom(val);
        content.append(el);
      } catch (ex) {
        console.log(ex);
      }
    });

    // Trigger hook event for external listeners
    $.event.trigger({ type: this.pageRenderHookEventName, href: href });
  }

  /**
   * Convert json structure to dom elements:
   * https://github.com/mobz/joey/blob/master/src/joey.js
   */
  // TODO: Remove this old method/dependency
  jsonToDom(elementDef, parentNode) {
    return this.createNode(elementDef, parentNode, parentNode ? parentNode.ownerDocument : global.document);
  }

  createNode(obj, parent, context) {

    var el, attr;
    if (obj == null) {
      return;
    } else if (typeof obj === 'string') {
      el = context.createTextNode(obj);
    } else {
      el = context.createElement(obj.tag || obj.tagName || 'DIV');
      for (attr in obj) {
        this.addAttr(el, attr, obj[attr], context);
      }
    }
    if (parent) {
      parent.appendChild(el);
    }
  
    return el;
  }

  addAttr(el, attr, value, context) {
    var shortcuts = {
      "text": "textContent",
      "cls": "className"
    };
    attr = shortcuts[attr] || attr;
  
    if (attr === 'children') {
      for (var i = 0; i < value.length; i++) {
        this.createNode(value[i], el, context);
      }
    } else if (attr === 'style' || attr === 'dataset') {
      for (var prop in value) {
        el[attr][prop] = value[prop];
      }
    } else if (attr.indexOf("on") === 0) {
      el.addEventListener(attr.substr(2), value, false);
    } else if (attr === 'textContent') {
      $(el).html(value);
    } else if (attr === 'height' || attr === 'width') {
      el[attr] = value.replace("px", "");
    } else if (attr === 'hashLink' && el["href"] === "") {
      el["href"] = value;
    } else {
      el[attr] = value;
    }
  }

  scrollTo($elem) {
    if (!$elem.length) {
      return false;
    }
  
    // Set a timeout to let content builder
    window.setTimeout(function () {
      var offsetTop = $elem.offset().top - 90;
      $("html, body").animate({ scrollTop: offsetTop }, "slow");
    }, 100);
  }

  setUXState(flags) {
    if (typeof flags !== "undefined") {
      // Toggle is-tutorial
      if (flags.isTutorial) {
        $(".tutorial-sidebar").addClass("is-active");
        $(".topbar, #footer").addClass("is-tutorial");
        $(".topbar .header").addClass("-is-tutorial");
        $(".page-wrap").addClass("is-active -gray-bg tutorial-detail");
      } else {
        $(".tutorial-sidebar").removeClass("is-active");
        $(".topbar, #footer").removeClass("is-tutorial");
        $(".topbar .header").removeClass("-is-tutorial");
        $(".page-wrap").removeClass("is-active -gray-bg tutorial-detail");
      }
  
      // Toggle is-search
      if (flags.isSearch) {
        $(".topbar, #footer, .hamburger").addClass("is-search");
        $(".search-open").addClass("hidden");
        $(".search-close").removeClass("hidden");
      } else {
        $(".topbar, #footer, .hamburger").removeClass("is-search");
        $(".search-close").addClass("hidden");
        $(".search-open").removeClass("hidden");
      }
    }
  
    var $tutorialSidebar = $(".tutorial-sidebar");
    if ($tutorialSidebar.length && $tutorialSidebar.hasClass("is-active")) {
      this.setUXStateTutorial($tutorialSidebar);
    }
  
    var $articlesIndex = $(".articles-index");
    if ($articlesIndex.length) {
      this.setUXStateArticle();
    }
  
    var $homeIndex = $(".home-start");
    if ($homeIndex.length) {
      this.setUXStateHome();
    }
  
    $(".hamburger, .primary-nav").removeClass("is-active");
  }

  setUXStateTutorial($sidebar) {
    var self = this;
    $sidebar.find("a.cms-link").removeClass("active");
    $sidebar.find("._group-wrap, ._toc").removeClass("is-active");
    var isFound = false;
  
    $sidebar.find("a.cms-link").each(function () {
      var $link = $(this);
  
      var currentUrl = self.sanitizeUrl(window.location.href);
      var linkUrl = self.sanitizeUrl($link.attr("href"));
  
      if (linkUrl === currentUrl) {
        isFound = true;
        $link.addClass("active");
        $link.closest("._group-wrap").find(".tutorial-link").addClass("active");
        $link.next("._toc").addClass("is-active");
        $link.closest("._toc").addClass("is-active");
        $link.closest("._group").find("._group-wrap").addClass("is-active");
      }
    });
  
    if (!isFound) {
      $sidebar.find("a.cms-link").each(function () {
        var $link = $(this);
        var stripUrlParams = true;
  
        var currentUrl = self.sanitizeUrl(window.location.href, stripUrlParams);
        var linkUrl = self.sanitizeUrl($link.attr("href"));
  
        if (linkUrl === currentUrl) {
          isFound = true;
          $link.addClass("active");
          $link.closest("._group-wrap").find(".tutorial-link").addClass("active");
          $link.next("._toc").addClass("is-active");
          $link.closest("._toc").addClass("is-active");
          $link.closest("._group").find("._group-wrap").addClass("is-active");
          return;
        }
      });
    }
  
    var $_footer = $("._footer");
    if ($_footer.length) {
      var $link = $_footer.find("a").clone().text("");
      var $column = $_footer.find(".g-column");
  
      $column.wrap($link);
    }
  }

  setUXStateArticle() {
    $(".articles-item").each(function () {
      var $column = $(this);
      var $heading = $column.find("h5");
      var $link = $column.find("a").last().clone().text("");
  
      $heading.wrap($link);
    });
  }

  setUXStateHome() {
    $(".home-section.-posts ._item").each(function () {
      var $column = $(this);
      var $heading = $column.find("h3");
      var $link = $column.find("a").last().clone().text("");
  
      $heading.wrap($link);
    });
  }

  getSectionFragment(url: string) {
    url = url || window.location.href;
    var result = false;
  
    // Strip url down to query params and look for section param first
    var urlParts = url.split("?");
    if (urlParts.length > 1) {
      var search = urlParts[1].split("#")[0];
      urlParts = search.split("&");
      urlParts.forEach((param) => {
        var kv = param.split("=");
        if (kv[0] === "section" && kv.length > 1) {
          result = "#" + kv[1];
          return;
        }
      });
    }
  
    // Strip url down to fragment and return that if found
    urlParts = url.split("#");
    if (urlParts.length > 1) {
      return "#" + urlParts[1];
    }
  
    return result;
  }

  sanitizeUrl(href: string, stripUrlParams?: boolean) {
    var result = href.replace(".html", "");
    var tmpUrl = result.split("/git/");
  
    if (tmpUrl.length <= 1) { return href; }
  
    result = tmpUrl[tmpUrl.length - 1];
  
    if (stripUrlParams) {
      result = result.split("?")[0].split("#")[0];
    }
  
    return result;
  }
}
